export default "__VITE_ASSET__CtFkXph$__"